import { ActionTypes } from "../constants";

const reduceQuestionnaires = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_MSF_QUESTIONNAIRE_LIST_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_MSF_QUESTIONNAIRE_SUCCESS:
            return !state ? [action.data] : [
                ...state.filter(({uuid}) => uuid !== action.data.uuid),
                action.data
            ];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getQuestionnaire = (questionnaires, questionnaireId) => !questionnaires ? [] : questionnaires.find(({uuid}) => uuid === questionnaireId);

export default reduceQuestionnaires;
